// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__ayshr","dragIcon":"SortableItem_dragIcon__I_jOt","disabled":"SortableItem_disabled__3TSCr"};